import React, { Component } from 'react';
import {
  Container, Row, Col, Button, Card, CardBody, CardImg,
} from 'reactstrap';
import { connect } from 'react-redux';
import Select, { createFilter } from 'react-select';
import { getAllClients } from '../../services/Clients/actions';
import { CustomLoading } from '../../components/Loading';
import { AllClientsTable } from '../../components/AllClientsTable';
import newClientImage from '../../Images/new-client.jpg';
import petsImage from '../../Images/pets.jpg';

class Home extends Component {
  state = {
    tempLoading: true,
  };

  componentDidMount() {
    this.props.getAllClients(() => {
      this.setState({
        tempLoading: false,
        backupClientList: this.props.Clients.clientList,
        tempClientList: this.props.Clients.clientList,
      });
    });
  }

  handlePincodeChange = (selectedOption) => {
    if (selectedOption) {
      this.setState({
        selectedPincode: selectedOption.label,
      }, () => {
        this.sortList();
      });
    } else {
      this.setState({
        selectedPincode: null,
      }, () => {
        this.sortList();
      });
    }
  };

  sortList = () => {
    const {
      backupClientList,
      selectedPincode,
    } = this.state;

    let holdingClientList = backupClientList;
    if (selectedPincode) {
      holdingClientList = holdingClientList.filter(item => item.pincode === selectedPincode);
    }
    this.setState({
      tempClientList: holdingClientList,
    });
  }


  handleChange = (selectedOption) => {
    this.props.history.push(`/client/${selectedOption.value}`);
  };


  render() {
    const {
      Clients: {
        pincodeList,
      },
    } = this.props;

    const {
      tempLoading,
      tempClientList,
    } = this.state;

    if (tempLoading) {
      return (
        <CustomLoading />
      );
    }

    return (
      <Container>
        <Row className="mt-3">
          <Col xs="12" md={{ size: 10, offset: 1 }}>
            <div className="d-flex justify-content-center">
              <h5>
                Search For Client
              </h5>
            </div>
            <Select
              onChange={this.handleChange}
              options={tempClientList}
              placeholder="Search Client / Pet"
              filterOption={createFilter({ ignoreAccents: false })}
            />
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs="6" md={{ size: 3 }}>
            <div className="d-flex justify-content-center">
              <Card body outline color="secondary">
                <CardImg top src={newClientImage} alt="Card image cap" />
                <CardBody>
                  <Button color="primary" block onClick={() => { this.props.history.push('/add-client'); }}>
                    Add Client
                  </Button>
                </CardBody>
              </Card>
            </div>
          </Col>
          <Col xs="6" md={{ size: 3 }}>
            <div className="d-flex justify-content-center">
              <Card body outline color="secondary">
                <CardImg top src={petsImage} alt="Card image cap" />
                <CardBody>
                  <Button color="primary" block onClick={() => { this.props.history.push('/pet-list'); }}>
                    See all pets
                  </Button>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
        <hr />
        <Row className="mt-3">
          <Col xs="12" md={{ size: 10, offset: 1 }}>
            <div className="d-flex justify-content-center">
              <h5>
                Client List
              </h5>
            </div>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs="12" md={{ size: 4 }}>
            <Select
              onChange={this.handlePincodeChange}
              options={pincodeList}
              placeholder="Sort with Pincode"
              isClearable="true"
            />
          </Col>
        </Row>
        <Row className="mt-3 mb-3">
          <AllClientsTable
            clientList={tempClientList}
            handleChange={this.handleChange}
          />
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  Clients: state.Clients,
});

const mapDispatchToProps = {
  getAllClients,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
